
import { type RouteRecordRaw } from 'vue-router';

export const authRoutes: RouteRecordRaw[] = [{
    path: 'login',
    name: 'login',
    meta: {
        public: true
    },
    component: () => import('./views/login/LoginView.vue')
}, {
    path: 'forgot-password',
    name: 'forgot-password',
    meta: {
        public: true
    },
    component: () => import('./views/forgotPassword/ForgotPasswordView.vue')
}, {
    path: 'setup-password',
    name: 'setup-password',
    meta: {
        public: true
    },
    component: () => import('./views/setupPassword/SetupPasswordView.vue')
}, {
    path: 'reset-password',
    name: 'reset-password',
    meta: {
        public: true
    },
    component: () => import('./views/resetPassword/ResetPasswordView.vue')
}, {
    path: 'sso/callback',
    name: 'sso-callback',
    meta: {
        public: true
    },
    component: () => import('./views/ssoCallback/SSOCallbackView.vue')
}, {
    path: 'sso/google',
    name: 'sso-google',
    meta: {
        public: true
    },
    component: () => import('./views/ssoGoogle/SSOGoogleView.vue')
}, {
    path: 'sso/microsoft',
    name: 'sso-microsoft',
    meta: {
        public: true
    },
    component: () => import('./views/ssoMicrosoft/SSOMicrosoftView.vue')
}];